var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Youtube logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49411 0C9.49411 0 3.55583 5.50921e-06 2.06541 0.387286C1.26738 0.610263 0.610265 1.26738 0.387286 2.07715C8.82369e-06 3.56758 0 6.65413 0 6.65413C0 6.65413 8.82369e-06 9.75241 0.387286 11.2194C0.610265 12.0291 1.25564 12.6745 2.06541 12.8975C3.56757 13.2965 9.49411 13.2965 9.49411 13.2965C9.49411 13.2965 15.4442 13.2965 16.9346 12.9092C17.7443 12.6863 18.3897 12.0526 18.6009 11.2311C19 9.75241 19 6.66587 19 6.66587C19 6.66587 19.0117 3.56758 18.6009 2.07715C18.3897 1.26738 17.7443 0.622014 16.9346 0.410769C15.4442 1.87671e-05 9.49411 0 9.49411 0ZM7.60465 3.80241L12.5454 6.65413L7.60465 9.49411V3.80241Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e3544eef.svg";
export { ForwardRef as ReactComponent };